module.exports = __webpack_public_path__ + "static/media/mobileScreenshot08.88277d8a.jpg";